<template>
  <div class="form-group" :class="classFormGroup">
    <label v-if="label" style="width: 100%">{{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="conditionalRequired" style="color: blue;"> *</span>
      <br>
      <span v-if="validation?.$error" style="color: red;">{{ messages }}</span>
    </label>
    <input
      type="text"
      :value="modelValue"
      ref="dateInput"
      class="date-input form-control"
      autocomplete="off"
      :placeholder="placeholder"
      :class="{ 'is-invalid': validation?.$error }"
      :disabled="disabled"
    />
  </div>
</template>

<script setup>
import $ from 'jquery';
import { defineEmits, defineProps, onMounted, ref } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    required: false,
  },
  classFormGroup: {
    type: String
  },
  modelValue: {
    type: String,
    default: null,
  },
  placeholder: {
    type: [ String, Boolean ],
    default: '',
  },
  label: {
    type: [ String, Boolean ],
    default: false,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  required: {
    type: Boolean,
    default: false,
  },
  conditionalRequired:{
    type: Boolean,
    default: false,
  },
  messages: {
    type: [ Object, String ], // Adjusted to accept both Object and String
    default: () => ({}),
  },
  inputStyle: Object,
  position: {
    type: String,
    default: 'up',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit      = defineEmits([ 'update:modelValue' ]);
const dateInput = ref(null);

onMounted(() => {
  $(dateInput.value).daterangepicker(
      {
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
          format: 'DD.MM.YYYY',
          separator: '.',
          useCurrent: false,
          firstDay: 1,
        },
        autoApply: true,
        closeOnDateSelect: true,
        autoUpdateInput: false,
        drops: props.position,
      },
      (start) => {
        $(dateInput.value).val(start.format('DD.MM.YYYY'));
        emit('update:modelValue', start.format('DD.MM.YYYY'));
      },
  );
  $(dateInput.value).on('apply.daterangepicker', function (ev, picker) {
    if (picker.startDate) { // DISABLE DEFAULT DATE IF IS NOT SELECTED IN DATE PICKER !!!
      $(this).val(picker.startDate.format('DD.MM.YYYY'));
      emit('update:modelValue', picker.startDate.format('DD.MM.YYYY'));
    }
  });

  $(dateInput.value).on('input', function (e, picker) {
    emit('update:modelValue', e.target.value);
  });
});
</script>

<style>

</style>